import { Box, Typography} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import * as api from '../services/api'
import styles from './healthAss.module.css'
import back from '../../assets/icons/back.svg';
import { useDispatch } from 'react-redux';
import { menuActive } from '../../store/menuSlice';
import Loader from '../../components/Loader';
import CustomizedModal from '../../components/modal/CustomizedModal';

function AssessmentResultDetail() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const docNumber = location.state?.doc_number;
  const evaluation_code = location.state?.evaluation_code 
  
  const handleCloseCancelModal = () => setShowCancelModal(false);
  const handleCloseSuccessModal = () => setShowSuccessModal(false);

  useEffect(() => {
    dispatch(menuActive('ผลการประเมินสุขภาพ'));
    fetchResult();
  }, []);

  const confirmChanges = () => {
    setShowCancelModal(false);
    setShowSuccessModal(false);
    navigate('/assessment'); 
  };

  const fetchResult = async () => {
        // const evaluation_code = docNumber; // Replace with the actual evaluation code
        setLoading(true);
        const res = await api.getAssessmentResultDetail(docNumber);
        let scores = [];
        setLoading(false);
        if (res) {
            if (res['data']['code'] === 200) {
                const detail = res['data']['data'];
                let currentScore;
                
                // Dynamically process each category in the data
                
                if (detail) {
                  // Initialize scores object with categories from the data
                  Object.keys(detail).forEach(category => {
                    if (Array.isArray(detail[category])) {
                      currentScore = 0;
                      
                      // Sum up scores for this category
                      detail[category].forEach(item => {
                        if (item.score !== null && !isNaN(item.score)) {
                          currentScore += parseInt(item.score);
                        }
                      });

                      scores.push({
                        index: category,
                        score: currentScore
                      })
                      currentScore = 0;
                    }
                  });
                }
                                
                evaluate(scores);
            } else {
                //alert(res['data']['message']);
            }
        } else {
          alert("ไม่ตอบสนอง");
        }
  };

  const evaluate = async (scores) => {
      setLoading(true);
      const res = await api.findFormEvaluation(null, null, evaluation_code);
      setLoading(false);
      let currentScore;
      let dataToBeSet = [];
      if (res['data']['code'] === 200) {
        const valuation_section = res['data']['data'][0]['evaluation_section'];
        for (let i = 0; i < valuation_section.length; i++) {
          if (valuation_section[i].interpret !== null) {
            currentScore = scores[i] ? parseInt(scores[i].score) : 0;
            for (let j = 0; j < valuation_section[i].interpret.length; j++) {
              if (parseInt(valuation_section[i].interpret[j].score_from) <= currentScore &&  
                  parseInt(valuation_section[i].interpret[j].score_to) >= currentScore) {
                  dataToBeSet.push({
                    index: i+1,
                    title: valuation_section[i].topic,
                    lable: valuation_section[i].interpret[j].recommend,
                    description: valuation_section[i].interpret[j].recommend_detail
                  });
                break;
              }
            }
          }
        }
        if (dataToBeSet.length === 0) {
          setShowSuccessModal(true);
        } else {
          setData(dataToBeSet);
        }
      }
      else {
        //alert(res['data']['message']);
      }
  }

  return (
    <>
    {/* Cancel Modal */}
    {showCancelModal && (
      <CustomizedModal
        onClose={handleCloseCancelModal}
        apiCall={confirmChanges}
        confirmMessage="ต้องการกลับไปหน้า แบบประเมินผลทั้งหมด?"
        confirmButtonText="ตกลง"
      />
    )}

    {/* Successful Modal */}
    {showSuccessModal && (
      <CustomizedModal
        onClose={handleCloseSuccessModal}
        apiCall={confirmChanges}
        confirmMessage="การประเมินผลสำเร็จ"
        confirmButtonText="ตกลง"
        allowCancel={false}
      />
    )}

    <Loader loading={loading} />

    {/* Back Button */}
    <Box sx={{ display: 'grid', gridGap: '10px' }}>
      <Box
        className={`${styles.bodyText} ${styles.inlineFlex}`}
        onClick={() => setShowCancelModal(true)}
        sx={{ cursor: 'pointer' }} // Added pointer cursor for better UX
      >
        <img src={back} alt="Previous" className={styles.directIcon} />
        กลับไปหน้า แบบประเมินทั้งหมด
      </Box>
    </Box>
    <Box
      sx={{
        backgroundColor: '#ebf5ff',
        padding: '20px',
        marginTop: '20px',
        width: '100vw', 
        marginLeft: '-50px', 
        marginRight: '-20px', 
        position: 'relative', 
      }}
    >      <Box
          sx={{
            fontWeight: 600,
            color: "#478F96",
            marginLeft: "30px",
            "@media (max-width: 800px)": {
              
            },
          }}
        >
          ผลการประเมิน
      </Box>
    </Box>

    {/* Loop */}
    {data.map((item, _) => (
    <Box
      sx={{
        marginTop: "20px",
        marginBottom: "20px",
      }}
      
    >
      
      <Typography variant="h7" sx={{ fontWeight: 600, color: "#478F96" }}>Part {item.index} : {item.title} </Typography>


      <Box
          sx={{
          border: "1px solid #AEB4DD",
          borderRadius: "5px",
          padding: "20px",
          marginTop: "20px",
          }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <Typography variant="h7" sx={{ fontWeight: 600,color: "#478F96"}}>{item.lable}</Typography>
        </Box>
        <Typography variant="body2">{item.description}</Typography>
      </Box>
    </Box>
  ))}

  </>
  );
}

export default AssessmentResultDetail;
